/**
 * @file LabelJobHideConfirm.tsx
 * @description Подтверждение «Скрыть файл» записи журнала печати этикеток
 *   (phase19.22 шаг 5, решение пользователя 2026-09-26).
 *
 * AlertDialog, а не мгновенное действие: вернуть файл нельзя, но и потери
 * нет — запись о печати остаётся, перепечатка доступна всегда. На `<sm` —
 * на весь экран (правило mobile-first).
 */

import { Loader2 } from "lucide-react";

import { LABEL_TEXT } from "./label-texts";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";
import { Button } from "../../ui/button";

interface Props {
  open: boolean;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function LabelJobHideConfirm({ open, busy, onCancel, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => (!o && !busy ? onCancel() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>{LABEL_TEXT.hideFileTitle}</AlertDialogTitle>
          <AlertDialogDescription>{LABEL_TEXT.hideFileText}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onCancel} disabled={busy}>
            Не сейчас
          </Button>
          <Button className="min-h-12" onClick={onConfirm} disabled={busy}>
            {busy ? <Loader2 className="size-4 animate-spin" /> : null}
            {LABEL_TEXT.hideFile}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
